import React, { Fragment } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink, useHistory } from "react-router-dom";
import { FaSignOutAlt } from "react-icons/fa";

const NavbarBunexe = ({ isLogin, info, setIsLogin }) => {
  const hist = useHistory();

  const logout = () => {
    localStorage.removeItem("token");
    setIsLogin(false);
    hist.push("/");
  };

  return (
    <Navbar collapseOnSelect expand="md" bg="primary" variant="dark">
      <Navbar.Brand as={NavLink} to="/bienvenue">
        Inscription
      </Navbar.Brand>

      {!isLogin && (
        <Nav className="flex-row">
          <Nav.Link
            as={NavLink}
            to="/demande_resultatbac"
            style={{ color: "white", fontWeight: "bold" }}
          >
            demande Resultat bac
          </Nav.Link>
          <Nav.Link
            as={NavLink}
            to="/e_document"
            style={{ color: "white", fontWeight: "bold" }}
          >
            e-document
          </Nav.Link>
          <Nav.Link
            as={NavLink}
            to="/verif_diplome"
            style={{ color: "white", fontWeight: "bold" }}
          >
            Verification diplome
          </Nav.Link>
        </Nav>
      )}

      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        {/* Vue Directeur d'École */}
        {isLogin && info?.role_id === "DI" && (
          <>
            <Nav className="mr-auto">
              <Nav.Link as={NavLink} to="/neuvieme">
                Neuvieme A.F
              </Nav.Link>
              <Nav.Link as={NavLink} to="/passutilisateur">
                Changer Mot de Passe
              </Nav.Link>
            </Nav>
            <Nav className="align-items-center">
              <span className="text-white h5 mb-0 mr-3">
                {info?.nom} {info?.prenom}
              </span>
              <button
                className="btn btn-outline-light btn-sm d-flex align-items-center"
                onClick={logout}
                title="Se déconnecter"
              >
                <FaSignOutAlt size={20} />
              </button>
            </Nav>
          </>
        )}

        {/* Vue Coordonnateur de District */}
        {isLogin && info?.role_id === "KO" && (
          <>
            <Nav className="mr-auto">
              <NavDropdown title="Liste de décision" id="ko-decision-dropdown">
                <NavDropdown.Item as={NavLink} to="/sec2">
                  Sec-II
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/sec3">
                  Sec-III
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/mat_anticipees">
                  Mat- Anticipées
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Bacc" id="ko-bacc-dropdown">
                <NavDropdown.Item as={NavLink} to="/sec4">
                  Sec-IV
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={NavLink} to="/passutilisateur">
                Changer Mot de Passe
              </Nav.Link>

              <Nav.Link as={NavLink} to="/e_diplome">
                e-diplôme
              </Nav.Link>

              <Nav.Link as={NavLink} to="/ecole_district">
                École / District
              </Nav.Link>
            </Nav>

            <Nav className="align-items-center">
              <span className="text-white h5 mb-0 mr-3">
                {info?.nom} {info?.prenom}
              </span>
              <button
                className="btn btn-outline-light btn-sm d-flex align-items-center"
                onClick={logout}
                title="Se déconnecter"
              >
                <FaSignOutAlt size={20} />
              </button>
            </Nav>
          </>
        )}

        {/* Vue Administrateurs / Agents BUNEXE */}
        {isLogin && info?.role_id !== "KO" && info?.role_id !== "DI" && (
          <>
            <Nav className="mr-auto">
              <Nav.Link as={NavLink} to="/board">
                Tableau de bord
              </Nav.Link>
              <Nav.Link as={NavLink} to="/neuvieme">
                Neuvième A.F
              </Nav.Link>

              <NavDropdown
                title="Liste de décision"
                id="admin-decision-dropdown"
              >
                <NavDropdown.Item as={NavLink} to="/sec2">
                  Sec-II
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/sec3">
                  Sec-III
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/mat_anticipees">
                  Mat- Anticipées
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Bacc" id="admin-bacc-dropdown">
                <NavDropdown.Item as={NavLink} to="/sec4">
                  Sec-IV
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/permns">
                  Permanent NS-IV
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={NavLink} to="/philo">
                  Philo
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/permph">
                  Permanent Philo
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Eni" id="admin-eni-dropdown">
                <NavDropdown.Item as={NavLink} to="/eni">
                  Eni Nouveau
                </NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="/enic">
                  Eni Capiste
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={NavLink} to="/saisie_notes_bac">
                Saisie Notes- Bacc
              </Nav.Link>

              {(info?.role_id === "SADM" || info?.role_id === "ADM") && (
                <Nav.Link as={NavLink} to="/utilisateur">
                  Utilisateurs
                </Nav.Link>
              )}

              {info?.role_id === "SADM" && (
                <Nav.Link as={NavLink} to="/periode">
                  Période saisie
                </Nav.Link>
              )}

              <Nav.Link as={NavLink} to="/passutilisateur">
                Changer Mot de Passe
              </Nav.Link>

              <Nav.Link as={NavLink} to="/ecole_district">
                École / District
              </Nav.Link>
            </Nav>

            <Nav className="align-items-center">
              <span className="text-white h5 mb-0 mr-3">
                {info?.nom} {info?.prenom}
              </span>
              <button
                className="btn btn-outline-light btn-sm d-flex align-items-center"
                onClick={logout}
                title="Se déconnecter"
              >
                <FaSignOutAlt size={20} />
              </button>
            </Nav>
          </>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default NavbarBunexe;
